<template>
	<div>
		<Header></Header>
		<div class="Dowload">
			<div class="first-img">
				<img src="../assets/xiazia/first@2x.png" alt="">
			</div>
			<!---->
			<div class="bgwrap">
				<div class="bgwrapicpn">
					<p><img src="../assets/xiazia/logo.png" alt=""></p>
					<p>云师教育app</p>
				</div>
				<div class="app_txt">
					<p>考教师，用云师就够了</p>
				</div>
				<div class="ermcode">
					<img src="../assets/xiazia/cc4.jpg">
				</div>
				<div class="ddapp">
					<div class="ddapp_left">
						<img src="../assets/xiazia/m1.png">
					</div>
					<div class="ddapp_right">
						<img src="../assets/xiazia/m2.png">
					</div>
				</div>
				<h3 class="thi-title">
					人性化刷题
				</h3>
				<h3 class="thi-title-english">
					HUMANIZATION
				</h3>
				<div class="thi-title-sec">
					制定每日计划，针对每题记笔记，重难点讲解
				</div>
				<!---->
				<div class="shuati">
					<img src="../assets/xiazia/phone1@2x.png" alt="">
					<h2 class="shuati-tit-1">训练薄弱章节</h2>
					<h2 class="shuati-tit-2">制定每日计划</h2>
				</div>
				<div class="shuati2">
					<h2 class="shuati-tit-1">题目小记</h2>
					<h2 class="shuati-tit-2">收藏重点题</h2>
					<img src="../assets/xiazia/phone2@2x.png" alt="">
				</div>
				<div class="shuati3">
					<h2 class="shuati-tit-1">错题多多练</h2>
					<h2 class="shuati-tit-2">收藏的题再练一遍</h2>
					<h2 class="shuati-tit-3">搜索薄弱知识点针对训练</h2>
					<img src="../assets/xiazia/phone3@2x.png" alt="">
				</div>

			</div>
			<div class="swiper1">
				<van-swipe :autoplay="3000" indicator-color="#007ccf" style='height:200px;'>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/dianpin.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">独创试讲在线点评</p>
							<p>上传试讲视频，专业老师在线点评指导</p>
							<p>面试提升快人一步</p>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/pingke.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">拼课更优惠</p>
							<p>精品课多人团报，和小伙伴一起学习，</p>
							<p>动力足优惠大</p>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/shangan.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">汇集全网招聘讯息+上岸好文</p>
							<p>及时更新招聘资讯，告别公众号信息淹没，</p>
							<p>永远不错过报名</p>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>

			<div class="teacher">
				<h3 class="teacher1">大咖讲师</h3>
				<h3 class="teacher2">FAMOUSLECTURER</h3>
				<p>
					每一位都是多年教学经验傍身的口碑名师，学员上岸率高达97.8%
				</p>
			</div>
			<div class="teacherList">


				<div class="teacherListmain">
					<van-swipe :autoplay="4000" indicator-color="#007ccf" style='height:460px;background: ;'>
						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/youzi.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">柚子老师</p>
								<p>
									云师顶级名师，理论功底深厚，讲课透彻清晰，逻辑严密，能够在基本知识， 教学设计，教学基本功能等方面给予针对性指导， 有效帮助学员掌握笔试学习以及面试策略
								</p>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/youyou.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">悠悠老师</p>
								<p>
									云师顶级名师，对于特岗，招教，教资考试考情分析透彻， 授课风格大方亲切，知识点明确，重点清新，理论功底深厚讲授透彻清晰，逻辑严密。
								</p>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/lijian.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">李建老师</p>

								<p>
									幽默风趣，走路带风，擅长用表情调动课堂情绪，授课风格深受学生喜爱，学员满意度高达99.9%，被学生评为"面试一哥"
								</p>
							</div>
						</van-swipe-item>

						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/shuaishuai.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">帅帅老师</p>
								<p>
									云师顶级名师，授课逻辑严谨以及幽默风趣中传授方法技巧， 教学形式灵活多样，对学员观察细致入微，善于发现学员特质并因材施教，深受广大考生欢迎。
								</p>
							</div>
						</van-swipe-item>


						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/douzi.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">豆子老师</p>

								<p>
									云师教育网红名师，上课风趣幽默，逻辑清晰，"案例，写作。教学设计"，豆子老师带你专门攻克难题，大题。带你轻轻松松得高分
								</p>
							</div>
						</van-swipe-item>

						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/mingming.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">铭铭老师</p>

								<p>
									云师教育顶级名师，十余年招教,资格证,特岗教育学研究和教学经验，累计培训上千场,成功培训学员上万人!
								</p>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/jingzi.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">镜子老师</p>

								<p>
									云师教育教学总监，讲课时而幽默，时而深沉， 不变的是极度，清晰的思路和言简意赅的讲解，深入浅出。带你愉快地走进心理学的殿堂
								</p>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="sw_img">
								<img src="../assets/xiazia/ranran.png">
							</div>
							<div class="p">
								<p style="text-align: center;line-height: 25px;">冉冉老师</p>
								<p>
									云师顶级名师，授课结构调理清晰，结合考点考题，针对性强。
								</p>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>

			</div>
			<!---->
			<div class="book-show">
				<h3 class="book1">教材展示</h3>
				<h3 class="book2">TEXTBOOK DISPLAY</h3>
				<p style="text-align: center;color: #999;font-size: 0.3rem;line-height: 34px;">
					专研定制教材配套APP学习，学法升级轻松先人一步
				</p>
			</div>
			<div class="book-showList">
				<van-swipe :autoplay="4000" indicator-color="#007ccf" style='height:350px;background: ;'>
					<van-swipe-item>
						<img src="../assets/xiazia/book1.png" height="350px" width="100%">
					</van-swipe-item>
					<van-swipe-item>
						<img src="../assets/xiazia/book2.png" height="350px" width="100%">
					</van-swipe-item>
					<van-swipe-item>
						<img src="../assets/xiazia/book3.png" height="350px" width="100%">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<!---->
		<div class="book-show-list">
			<div class="book_300">
				<ul>
					<li>
						<div class="li_left">
							<img src="../assets/xiazia/dow1.png">
						</div>
						<div class="li_right">
							<p>提分效果升级</p>
							<p>一学就懂不留疑惑</p>
						</div>
					</li>
					<li>
						<div class="li_right1">
							<p>提分效果升级</p>
							<p>一学就懂不留疑惑</p>
						</div>
						<div class="li_left1">
							<img src="../assets/xiazia/dow2.png">
						</div>
					</li>
					<li>
						<div class="li_left">
							<img src="../assets/xiazia/dow3.png">
						</div>
						<div class="li_right">
							<p>学习效率更高</p>
							<p>学霸独家学习方法</p>

						</div>
					</li>
				</ul>
			</div>
		</div>
		<!--即将上线-->
		<div class="go-online">
			<h3 class="online-cn">即将上线</h3>
			<h3 class="online-en">SOON TO GO ONLINE</h3>
		</div>
		<div class="go-onlinebox">
			<div class="swiper1">
				<van-swipe :autoplay="3000" indicator-color="#007ccf" style='height:240px;'>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/za1.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">千人千面智能学习方案，量身定制，拒绝无营养</p>
							<p>1、专人专师一对一诊断学习弱点，快一步上岸</p>
							<p>2、AI智能生成专属模拟卷，针对性查缺补漏考点</p>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/za3.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">创新学习方式，get考点so esay</p>
							<p>1、视频/音频随意切换，骑车走路方便听</p>
							<p>2、AI智能生成专属模拟卷，针对性查缺补漏考点</p>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper1bg">
							<img style="width:75px;height: 60px;" src="../assets/xiazia/za2.png" alt="">
						</div>
						<div class="swiper1txt">
							<p style="color: #7BC7FF;">努力就有回报，学费轻轻松松赚回来</p>
							<p>2、学习累计时长可兑换课程</p>
							<p>3、学霸报班优惠多多</p>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Dowload',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {
			openinfo() {
				this.$router.push({
					path: '/FenDetail',
					name: 'FenDetail',
				})
			}
		}
	}
</script>

<style scoped>
	.first-img {
		background: linear-gradient(180deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		background-repeat: no-repeat;
		background-size: 100% 170%;
		text-align: center;
	}

	.first-img img {
		width: 80%;
		margin: 0 auto;
	}

	.bgwrap {
		background: -webkit-linear-gradient(-90deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		background: -o-linear-gradient(-90deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		background: -ms-linear-gradient(-90deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		background: -moz-linear-gradient(-90deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		background: linear-gradient(-90deg, rgba(255, 221, 239, 1) 0, rgba(181, 247, 255, 1) 100%);
		height: 1661px;
	}

	.bgwrapicpn {
		width: 80%;
		height: 50px;
		margin: 0 auto;
		display: flex;
	}

	.bgwrapicpn p:nth-child(1) {
		width: 80px;
		height: 50px;
	}

	.bgwrapicpn p:nth-child(1) img {
		width: 80px;
		height: 50px;
	}

	.bgwrapicpn p:nth-child(2) {
		flex: 1;
		margin-left: 20px;
	}

	.bgwrapicpn p:nth-child(2) {
		font-size: 30px;
		font-weight: bold;
		color: #333;
	}

	.app_txt {
		width: 100%;
		height: 50px;
	}

	.app_txt p {
		text-align: center;
		line-height: 30px;
		font-size: 23px;
		color: #999;
	}

	.ermcode {
		width: 200px;
		height: 200px;
		margin: 0 auto;
	}

	.ermcode img {
		width: 200px;
		height: 200px;
	}

	.ddapp {
		width: 80%;
		height: 40px;
		margin: 20px auto;
	}

	.ddapp_left {
		width: 140px;
	}

	.ddapp_left img {
		width: 140px;
		height: 40px;
	}

	.ddapp_right {
		width: 140px;
		float: right;
		margin-top: -43px;
	}

	.ddapp_right img {
		width: 140px;
		height: 40px;
	}

	.thi-title {
		margin-top: .6rem;
		padding-top: .3rem;
		text-align: center;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 43px;
	}

	.thi-title-english {
		padding-top: .1rem;
		text-align: center;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		opacity: .9;
	}

	.thi-title-sec {
		text-align: center;
		font-size: .28rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		padding: .1rem 0;
		margin-bottom: .4rem;
		color: rgba(153, 153, 153, 1);
	}

	.shuati {
		position: relative;
		text-align: center;
	}

	.shuati img {
		width: 60%;
	}

	.shuati .shuati-tit-1 {
		position: absolute;
		right: 1%;
		top: 26%;
	}

	.shuati h2 {
		font-size: .28rem;
		font-family: PingFang SC;
		font-weight: 600;
		color: rgba(115, 120, 250, 1);
	}

	.shuati .shuati-tit-2 {
		position: absolute;
		left: 1%;
		bottom: 28%;
	}

	.shuati2 {
		margin-top: .5rem;
		position: relative;
		text-align: center;
	}

	.shuati2 .shuati-tit-1 {
		position: absolute;
		right: 11%;
		bottom: 26%;
	}

	.shuati2 .shuati-tit-2 {
		position: absolute;
		right: 8%;
		bottom: 20%;
	}

	.shuati2 h2 {
		font-size: .28rem;
		font-family: PingFang SC;
		font-weight: 600;
		color: rgba(115, 120, 250, 1);
	}

	.shuati2 img {
		width: 45%;
	}

	.shuati3 {
		margin-top: .5rem;
		padding-bottom: .5rem;
		position: relative;
		text-align: center;
	}

	.shuati3 .shuati-tit-1 {
		position: absolute;
		right: 5%;
		top: 30%;
	}

	.shuati3 .shuati-tit-2 {
		position: absolute;
		left: 8%;
		bottom: 42%;
		width: 16%;
		overflow: hidden;
	}

	.shuati3 h2 {
		font-size: .28rem;
		font-family: PingFang SC;
		font-weight: 600;
		color: rgba(115, 120, 250, 1);
	}

	.shuati3 .shuati-tit-3 {
		position: absolute;
		right: 4%;
		bottom: 20%;
		width: 20%;
	}

	.shuati3 img {
		width: 53%;
	}

	.teacher .teacher1 {
		margin-top: .4rem;
		text-align: center;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
	}

	.teacher .teacher2 {
		padding: .2rem 0;
		font-size: .28rem;
		font-family: PingFang SC;
		font-weight: 300;
		text-align: center;
		color: rgba(153, 153, 153, 1);
		line-height: 45px;
	}

	.teacher p {
		width: 80%;
		margin: 0 auto;
		text-align: center;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
	}

	.swiper1txt {
		text-align: center;
		line-height: 30px;
		color: #666;
		font-size: 14px;
	}

	.swiper1bg {
		width: 75px;
		height: 45px;
		margin: 20px auto;
	}

	.swiper1txt {
		margin-top: 20px;
	}

	.swiper1bg img {
		margin: 0px auto;
	}

	.teacher {
		height: 184px;
		margin: 20px auto;
	}

	.teacherList {
		width: 100%;
		height: 460px;
		background: rgba(255, 255, 255, 1);
		background: skyblue;
		margin: 10px auto 10px auto;
		position: relative;
	}

	.teacherListmain {
		width: 300px;
		height: 460px;
		background: #fff;
		position: absolute;
		top: -70px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		margin: auto;
	}

	.sw_img {
		width: 95%;
		height: 220px;
		position: absolute;
		left: 7px;
	}

	.sw_img img {
		width: 100%;
		height: 100%;
	}

	.teacherListmain .p {
		position: absolute;
		top: 230px;
		left: 7px;
	}

	.teacherListmain .p p:nth-child(2) {
		color: #999;
		font-size: 14px;
		line-height: 25px;
	}

	.book-show .book1 {
		margin-top: .4rem;
		text-align: center;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 45px;
	}

	.book-show .book2 {
		padding: .2rem 0;
		font-size: .28rem;
		font-family: PingFang SC;
		font-weight: 300;
		text-align: center;
		color: rgba(153, 153, 153, 1);
	}

	.book-showList {
		width: 300px;
		margin: 0 auto 30px auto;
	}

	.book-show-list {
		width: 300px;
		height: 350px;
		background: aliceblue;
		margin: 30px auto;
	}

	.book-show-list ul li {
		list-style: none;
		height: 100px;
		margin: 26px 0;
		position: relative;
	}

	.book-show-list ul li {
		list-style: none;
		height: 100px;
		margin: 26px 0;
		position: relative;
	}

	.book-show-list ul li {
		list-style: none;
		height: 100px;
		margin: 26px 0;
		position: relative;
	}

	.li_right {
		width: 180px;
		height: 100px;
		position: absolute;
		top: 0;
		right: 0;
	}

	.li_right p:nth-child(1) {
		font-size: 22px;
		color: #7bc7ff;
		margin-top: 25px;
		margin-left: 20px;
	}

	.li_right p:nth-child(2) {
		color: #666;
		margin-left: 20px;
	}

	.li_right1 {
		width: 180px;
		height: 100px;
		position: absolute;
		top: 0;
		left: 0;
	}

	.li_right1 p:nth-child(1) {
		font-size: 22px;
		color: #7bc7ff;
		margin-top: 25px;
	}

	.li_right1 p:nth-child(2) {
		color: #666;
	}

	.li_left1 {
		width: 100px;
		height: 100px;
		position: absolute;
		top: 0;
		right: 0;
	}

	.li_left1 img {
		width: 100%;
		height: 100%;
	}

	.go-online .online-cn {
		margin-top: .4rem;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 38px;

	}

	.go-online .online-en {
		padding: .2rem 0;
		font-size: .28rem;
		font-weight: 300;
		text-align: center;
		color: rgba(153, 153, 153, 1);
	}

	.go-onlinebox {
		margin: 20px auto 40px auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dowload.vue